<template>
  <div class="listwrap">
    <div style="position:sticky; top:-78px;z-index: 99;background: #fff;">
      <swiper :adData="adData"></swiper>

      <div @click="postNew" class="fbxt">
        <img src="../../assets/img/addpostIcon.png" alt="" />
        发布新帖
      </div>
    </div>
    <div class="secitonItem">
      <van-list v-model="loading" :finished="finished" :finished-text="list.length ? '没有更多了' : ''" @load="onLoad">
        <div v-if="list.length">
          <item class="itembox" v-for="(item, index) in list" :key="index" :class="isToday(item.createtime) ? 'ac' : ''"
            :item="item" :type="2"></item>
        </div>
        <van-empty v-else description="暂无信息" />
      </van-list>
    </div>
  </div>
</template>
<script>
import swiper from '../components/swiper.vue';
import item from '../components/item.vue';
import { plateList, getSubPostIds, dumpPostPage } from '@/api/base';
import { isToday } from '@/utils/index';
export default {
  components: { swiper, item },
  data() {
    return {
      adData: this.$store.state.app.adBanner.smallList,
      refreshing: false,
      loading: false,
      finished: false,
      page: {
        rows: 10,
        current: 1,
        scrollid: null,
      },
      list: [],
      subPostIds: [],
    };
  },
  created() {
    this.verification();
  },
  methods: {
    async verification() {
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      if (userinfo == null) {
        console.log('为空');
        this.$router.replace('/yclogin');
        return;
      }
      getSubPostIds({ openId: window.openId }).then(res => {
        this.subPostIds = res.data;
      });
    },
    postNew() {
      let that = this;
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      if (userinfo.grade.indexOf('纯买家会员') != -1) {
        this.$dialog
          .confirm({
            message: '纯买家会员没有发帖权限',
            confirmButtonText: '进入',
            cancelButtonText: '取消',
          })
          .then(() => {
            that.$router.push({
              path: '/createPost',
            });
          })
          .catch(() => {
            // on cancel
          });
        return;
      } else {
        that.$router.push({
          path: '/createPost',
        });
      }
    },
    isToday,
    async onLoad() {
      // this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   message: '...',
      // });
      let userinfo = JSON.parse(window.localStorage.getItem('ycUserinfos'));
      // console.log(infos);
      // let obj = {
      //   filter: { sectionCode: null, field: 'author', type: null },
      //   query: {
      //     indexname: 'post',
      //     keyWords: infos.userName,
      //     rows: 10,
      //     current: this.page.current,
      //     scrollid: this.page.scrollid,
      //     sort: 'lastupdatetime',
      //   },
      //   openId: 'oFQ7G5vJ1X0v-YHs4eROQUIAVNFU',
      // };



      let obj = {
        userName: userinfo.userName,
        passWord: userinfo.passWord,
        uuid: userinfo.uuid,
        page: this.page.current,
        url: 'url'
      }
      dumpPostPage(obj)
        .then(res => {
          // res.data.data.map(item => {
          //   item.subscribe = true;
          // });
          res.data.map(item => {
            return (item.subscribe = this.subPostIds.indexOf(item.id) != -1 ? true : false);
          });
          let tmpList = res.data || [];
          let list = this.list || [];



          let valueToFind = tmpList[0].postId
          let found = list.some(it => it.postId === valueToFind);
          this.finished = found;
          this.loading = false;
          if (found) {
            return
          }
          if (this.refreshing) {
            list = tmpList;
            this.refreshing = false;
          } else if (tmpList.length) {
            list = [...list, ...tmpList];
          } else {
            this.finished = true;
          }
          this.loading = false;
          this.list = list;
          // this.list = this.insertAndSort(list);
          // this.page.scrollid = res.data.scrollid;
          this.page.current++;
          // this.$toast.clear();
        })
        .catch(error => {
          this.finished = true;
          this.loading = false;
        });
    },
    onRefresh() {
      this.list = [];
      this.refreshing = true;
      this.finished = false;
      this.page = { current: 1, size: 10, scrollid: null };
      this.onLoad();
    },
    insertAndSort(list) {
      console.log(list);
      let locList = JSON.parse(window.localStorage.getItem('createPostList')) || [];
      console.log(locList);
      // 过滤出在B中不存在的ID并将它们插入到B数组的前面
      const arr = [];
      locList.forEach(item => {
        if (!list.find(b => b.postId === item.postId)) {
          arr.unshift(item);
        }
      });
      arr.push(...list); // 将原始B数组中的剩余项添加到新数组的末尾
      // 根据createTime字段进行倒序排序
      const sortedItems = [...arr].sort(
        (a, b) => new Date(b.lastupdatetime) - new Date(a.lastupdatetime),
      );
      console.log(sortedItems);
      return sortedItems;
    },
  },
};
</script>
<style lang="less" scoped>
.listwrap {
  .fbxt {
    padding: 12px 0;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 24.7px;
    color: rgba(68, 71, 54, 1);
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      display: block;
      width: 23px;
      height: 23px;
      margin-right: 8px;
    }
  }

  .secitonItem {
    .itembox {
      box-shadow: 0px 0px 25.5px rgba(242, 245, 233, 1);
      margin-bottom: 5px;
    }

    .itembox.ac {
      background: rgba(176, 235, 199, 0.8);
    }
  }
}
</style>
